import React from "react";
import { FaRobot } from "react-icons/fa";
import BasicBars from "./BarChart";
import BasicLineChart from "./BarGradient";

const botStats = [
  { channelName: "Lowcode", botCount: 14, color: "#4CAF50" },
  { channelName: "HRMS", botCount: 9, color: "#2196F3" },
  { channelName: "Insurance", botCount: 23, color: "#F44336" },
  { channelName: "Analytics", botCount: 5, color: "#FFA000" },
];

function ChannelBotCards() {
  return (
    <div className="container mt-4">
     
      <div className="row">
        {botStats.map((channel, idx) => (
          <div className="col-12 col-lg-3 col-md-4 col-sm-6 col-md-3 mb-4" key={idx}>
            <div
              className="card shadow-sm h-100"
              style={{ borderLeft: `5px solid ${channel.color}` }}
            >
              <div className="card-body d-flex flex-column justify-content-between">
                <div className="d-flex justify-content-between align-items-center">
                  <h3 className="mb-0">{channel.botCount}</h3>
                  <FaRobot size={30} color={channel.color} />
                </div>
                <h5 className="mt-3">{channel.channelName}</h5>
                <hr />
                <p className="text-muted mb-0" style={{ fontSize: "0.85rem" }}>
                  Bots created in this channel
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="row">
        <BasicLineChart/>
        <BasicBars/>
      </div>
    </div>
  );
}

export default ChannelBotCards;
